const lease = [{
    cName: "AUTOMOBILES, LEASE",
    oSubMenu: [{
            cName: "09 LEASE Vehicle, Automobile, (under 9 passenger)",
            cReturn: "09 LEASE Vehicle, Automobile, (under 9 passenger)|a3|a3|a3|a6|a6|a6|a12|a12|a12|a12|a12|a12|a13|a15|a15|6|a12|pa|2|1|9|9"
        }, //FS320.08(6)a
        {
            cName: "09 Automobile, for HIRE, SPECIAL ANY 6 Month period, (under 9 passenger)",
            cReturn: "Automobile, for HIRE, SPECIAL ANY 6 Month period, (under 9 passenger)|a66|a66|a66|a66|a66|a66|a66|a66|a66|a66|a66|a66|a66|a66|a66|6|2|pa66|2||9|92"
        }
    ] //FS320.08(6)a?
}, {
    cName: "TRAILERS, FOR HIRE",
    oSubMenu: [{
            cName: "54 Trailers, for HIRE thru 1999 lbs",
            cReturn: "54 Trailers, for HIRE thru 1999 lbs|t3|t3|t3|t6|t6|t6|t12|t12|t12|t12|t12|t12|t13|t15|t15|6|t12|pt|2|2|54|54"
        }, //FS320.08(8)a
        {
            cName: "54 Trailers, for HIRE, 2000 lbs and over",
            cReturn: "54 Trailers, for HIRE 2000 lbs and over|tp3|tp3|tp3|tp6|tp6|tp6|tp12|tp12|tp12|tp12|tp12|tp12|tp13|tp15|tp15|6|tp12|ptp|2|2|54|54"
        }, //FS320.08(8)b
    ]
}];

module.exports = lease;



// WEBPACK FOOTER //
// ./src/modules/data/lease.js